export default __webpack_public_path__ + "static/media/user.4ae5106a.png";